module.exports = __webpack_public_path__ + "static/media/left-image.ca6bd50e.png";